<img *ngIf="loading" [src]="imagePath" />
